import { useCallback } from 'react';
import { addMinutes } from '../../../utils/dateUtils';
import EventLogTypeDTO from '@src/adapters/dto/eventLog/EventLogTypeDTO';
import useGetEventLogTypesLazy from './useGetEventLogTypes';

interface CacheItem {
  expiryDate: Date;
  data: EventLogTypeDTO[];
}

const cacheEntryTtlMins = 240;
const eventLogTypeCache: { [key: string]: CacheItem } = {};

const useGetEventLogTypesLocal = () => {
  const { execute } = useGetEventLogTypesLazy();

  const getTypes = useCallback(
    async (refresh?: boolean): Promise<EventLogTypeDTO[]> => {
      if (
        eventLogTypeCache &&
        eventLogTypeCache['eventLog'] &&
        (eventLogTypeCache['eventLog'].expiryDate === undefined ||
          new Date(eventLogTypeCache['eventLog'].expiryDate).getTime() >
            new Date().getTime()) &&
        !refresh
      ) {
        return Promise.resolve(eventLogTypeCache['eventLog'].data);
      } else {
        const result = await execute();

        eventLogTypeCache['eventLog'] = {
          expiryDate: addMinutes(new Date(), cacheEntryTtlMins)!,
          data: result.types,
        };

        return eventLogTypeCache['eventLog'].data;
      }
    },
    [execute]
  );
  return {
    getTypes,
  };
};

export default useGetEventLogTypesLocal;
